import Image from 'next/image';
import styled from 'styled-components';
import { TestimonialCardSVG } from '../../../../../shared/components/talentpool/TestimonialCardSVG';
import { Container, ContainerContentStandard } from '../../../../../shared/styles/container';
import { device } from '../../../../../shared/styles/device';
import { Headline, SubHeadline } from '../../../../../shared/styles/headline';
import FrSvg from '/public/svg/talentpool/agenturen/fr-logo-new.svg';

const TestimonialsSectionContainer = styled.section`
  display: flex;
  flex-direction: column;

  h2 {
    margin-bottom: 8px;
  }
  h3 {
    margin-bottom: 48px;
  }
`;
const TestimonialCardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 48px 0px;

  svg {
    max-height: 65px;
    max-width: 200px;
  }

    @media ${device.tablet} {
      column-gap: 128px;
      flex-wrap: nowrap;
  }

`;

export const TestimonialsSectionTP = () => {
  const testimonials1 = [
    {
      testimonial: "Das STELL-MICH-EIN ermöglicht einen Einblick in die Lebenswelt der jungen Menschen und verrät etwas über deren Gedanken, Ansprüche und prüft, ob generell die Chemie stimmt.",
      name: "Sven Zimmermann",
      company: "PANORAMA3000",
      isSVG: false,
      CompanySVG: <Image
        src="/images/talentpool/landing/agenturen/panorama.png"
        alt="PANORAMA3000 Logo"
        layout='fixed'
        height={60}
        width={160}
        quality={100}
        objectPosition="contain"
        objectFit='contain'
      />
    },
    {
      testimonial: "Seit 2014 nehmen wir schon am STELL-MICH-EIN teil und haben dort tolle Bewerber*innen kennengelernt. Die besten arbeiten jetzt bei uns ;-)",
      name: "Jens Zimmer",
      company: "familie redlich",
      isSVG: true,
      CompanySVG: FrSvg
    }
  ]
  const testimonials2 = [
    {
      testimonial: "STELL-MICH-EIN war ein voller Erfolg für uns! Von den insgesamt 30 Kandidaten haben wir sechs zu einer zweiten Runde eingeladen - und bisher zwei davon einen Job angeboten. Eine Kandidatin hat bereits bei uns angefangen. Wir können eine Teilnahme definitiv empfehlen. Es lohnt sich, selbst dann, wenn es nicht um eine konkret zu besetzende Position geht, sondern um Kontakte zu Potentials zu knüpfen.",
      name: "Julia Maria Kaiser",
      company: "Schwartz PR",
      isSVG: false,
      CompanySVG: <Image
        src="/images/talentpool/landing/agenturen/spr.jpg"
        alt="Schwartz PR Logo"
        layout='fixed'
        height={60}
        width={160}
        quality={100}
        objectPosition="contain"
        objectFit='contain'
      />
    },
  ]
  return (
    <TestimonialsSectionContainer>
      <Container centered>
        <ContainerContentStandard>
          <Headline>Unsere Agenturen sind <span>begeistert</span>.</Headline>
          <SubHeadline>STELL-MICH-EIN begleitet seit Jahren die Top-Unternehmen der Branche</SubHeadline>
          <TestimonialCardsContainer>
            {testimonials1.map((item: any, index) => <TestimonialCardSVG key={item.name + index} CompanySVG={item.CompanySVG} company={item.company} testimonial={item.testimonial} name={item.name} isSVG={item.isSVG} />)}
          </TestimonialCardsContainer>
          <TestimonialCardsContainer>
            {testimonials2.map((item: any, index) => <TestimonialCardSVG key={item.name + index} CompanySVG={item.CompanySVG} company={item.company} testimonial={item.testimonial} name={item.name} isSVG={item.isSVG} />)}
          </TestimonialCardsContainer>
        </ContainerContentStandard>
      </Container>
    </TestimonialsSectionContainer>
  )
}
